import { Button } from '../../../../../../components/button/button';
import { Card } from '../../../../../../components/card/card';
import { Container } from '../../../../../../components/container/container';
import { Divider } from '../../../../../../components/divider/divider';
import { Input } from '../../../../../../components/input/input';
import { Select } from '../../../../../../components/select/select';
import { validateLang } from '../../../../../../helpers/lang';
import { validate } from '../../../../../../helpers/validate';
import { useLang } from '../../../../../../hooks/use-lang';
import { useLeadStore } from '../../../../../../store/use-lead-store';
import { ageOptions, formFields, sexOptions } from '../../helpers';
import s from './lead-preview.module.css';

export const LeadPreview = () => {
  const { lead, postLead, isLoading } = useLeadStore();
  const { t, getLocale } = useLang();

  const handleSave = () => {
    const isValid = validate({
      hello: { rule: () => validateLang(lead?.title) },
    });
    if (!isValid) return;
    postLead();
  };

  return (
    <Card className={s.feature} title={`2. ${t('Превью')}`}>
      <div className={s.form}>
        <h4 className={s.title}>{getLocale(lead?.title)}</h4>
        {formFields.map(({ id, value }) => {
          const input = lead?.content?.find((field) => id === field.type);
          const type = input?.type;
          const is_required = input?.is_required;
          if (!input) {
            return null;
          }

          let element = null;
          if (type === 'sex') {
            element = (
              <Select options={sexOptions.map((item) => ({ ...item, value: t(item.value) }))} />
            );
          } else if (type === 'age') {
            element = (
              <Select options={ageOptions.map((item) => ({ ...item, value: t(item.value) }))} />
            );
          } else {
            element = <Input onChange={() => {}} />;
          }
          return (
            <Container key={type} label={t(value)} required={is_required}>
              {element}
            </Container>
          );
        })}
        <Button>{t('Отправить')}</Button>
      </div>
      <Divider />
      <Button variant="secondary" onClick={handleSave} disabled={isLoading}>
        {t('Сохранить форму')}
      </Button>
    </Card>
  );
};
